  import Vue from 'vue';

  const state = () => ({
    cdPessoa: null,
    cdPessoaNome: null,
    selecaoLote: null,
    selecaoStatus: null,
    dataImportacao: null
  });

  const mutations = {
    SET_FILTRO(state, filtro) {
    const validKeys = Object.keys(state);
    validKeys.forEach(key => {
      if (key in filtro) {
        Vue.set(state, key, filtro[key]);
      }
    });
  },

    RESET_FILTROS(state) {
      Object.keys(state).forEach(key => {
        Vue.set(state, key, null);
      });
    }
  };

  const getters = {

    filtroCompleto: (state) => state,

    cdPessoa: (state) => state.cdPessoa,
    selecaoLote: (state) => state.selecaoLote,
    cdPessoaNome: (state) => state.cdPessoaNome,
    selecaoStatus: (state) => state.selecaoStatus,
    dataImportacao: (state) => state.dataImportacao,

    hasFiltrosAtivos: (state) => {
      return Object.values(state).some(value =>
        value !== null && value !== undefined && value !== ''
      );
    }
  };

  const actions = {
    setFiltro({ commit }, filtro) {
      commit('SET_FILTRO', filtro);
    },

    setFiltroCampo({ commit }, { campo, valor }) {
    const update = { [campo]: valor };
    commit('SET_FILTRO', update);
  },

    limparFiltros({ commit }) {
      commit('RESET_FILTROS');
    },
  };

  export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
  };
